<script>
import TwButton from '@/components/generic/tw-button.vue'
import FundraiserRightColumn from '@/components/fundraisers/public/fundraiser-right-column.vue'
import FundraiserLeftColumn from '@/components/fundraisers/public/fundraiser-left-column.vue'
import TwContainerFullWidth from '../../../../../components/generic/tw-container-full-width.vue'
import fundraiserPublicFetchMixin from '@/mixins/fundraiserPublicFetchMixin.js'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import FundraiserTopHeader from '@/components/fundraisers/public/fundraiser-top-header.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'

export default {
  name: 'FundraiserLayoutModern' ,
  components: { GrouprevPublicFooter, FundraiserTopHeader, TwContainerFullWidth, FundraiserLeftColumn, FundraiserRightColumn, TwButton },
  mixins:[fundraiserPublicFetchMixin, loggedInUserMixin],
  methods: { useFundraiserPublicStore },
}
</script>

<template>
  <div v-if="fundraiser && (fundraiser.published || (loggedInUser && loggedInUser.id === fundraiser.owner_user_id))">
    <fundraiser-top-header :fundraiser="fundraiser" class="py-4" />
    <div v-if="fundraiser.cover_image_url" class="bg-cover bg-no-repeat bg-center bg-overlay md:min-h-60 lg:min-h-96 flex items-center" :style="`background-image: url('${fundraiser.cover_image_url}');`">
      <tw-container-full-width class="pt-7 pb-8 lg:py-20 max-w-[1360px]">
        <div class="grid lg:grid-cols-3 gap-8 overflow-hidden items-center">
          <div class="flex flex-col gap-3 md:gap-4 col-span-2 text-white text-center sm:text-left py-5 lg:pr-12">
            <h1 class="header-xl">
              {{ fundraiser.title }}
            </h1>
            <p class="md:text-lg leading-5" v-html="fundraiser.short_description" />
          </div>
        </div>
      </tw-container-full-width>
    </div>
    <tw-container-full-width class="relative max-w-[1360px] lg:pb-8">
      <div class="grid lg:grid-cols-3 grid-cols-1 gap-0">
        <div class="lg:col-span-1 lg:order-last relative mt-8 lg:mt-0 lg:-top-80"><fundraiser-right-column :fundraiser="fundraiser"/></div>
        <fundraiser-left-column :fundraiser="fundraiser" class="lg:col-span-2 relative lg:static lg:pr-12" />
      </div>
    </tw-container-full-width>
    <grouprev-public-footer :class='fundraiser.settings.force_donating_to_fundraiser_pages_only ? "lg:mb-8 mb-[260px]" : "lg:mb-8 mb-[200px]"' />

  </div>
  <div v-else-if="Loading" class="flex items-center justify-center mt-6">
    <div class="flex items-center justify-center w-40 h-40 border border-gray-200 rounded-lg bg-gray-50 mt-10">
      <div role="status">
        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="container mx-auto mt-4 p-4">
      <div class="text-center">
        <div class="text-2xl font-bold">
          This fundraiser is not available
        </div>
        <div class="mt-4">
          <tw-button :to="{name: 'Home'}" size="lg">
            Go back to the home page
          </tw-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
